module.exports = __webpack_public_path__ + "img/t5-15.3480ccf0.svg";